import axiosInstance from '@/utils/api.js'

var state = {
  switches: [],
  switches_paged: [],
  switchPortsUsage: [],
  dhcpPoolLinks: []
}

var getters = {
  SWITCHES: (state) => {
    return state.switches
  },
  SWITCHES_PAGED: (state) => {
    return state.switches_paged
  },
  SWITCHE_PORTS_USAGE: (state) => {
    return state.switchPortsUsage
  },
  DHCP_POOL_LINKS: (state) => {
    return state.dhcpPoolLinks
  }
}

var mutations = {
  SET_SWITCHES: (state, payload) => {
    state.switches = payload
  },
  SET_SWITCHES_PAGED: (state, payload) => {
    state.switches_paged = payload
  },
  SET_SWITCHE_PORTS_USAGE: (state, payload) => {
    state.switchPortsUsage = payload
  },
  SET_DHCP_POOL_LINKS: (state, payload) => {
    state.dhcpPoolLinks = payload
  }
}

var actions = {
  GET_SWITCHES_PAGED: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/switches_paged?page=' + payload.page + '&per_page=' + payload.perPage + '&filter=' + payload.filter)
    if (result.status === 200) {
      context.commit('SET_SWITCHES_PAGED', result.data)
    }
  },
  GET_SWITCHES: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/switches?page=' + payload.page + '&per_page=' + payload.perPage + '&filter=' + payload.filter)
    if (result.status === 200) {
      context.commit('SET_SWITCHES', result.data)
    }
  },
  CREATE_SWITCHES: (context, payload) => {
    return axiosInstance.post('/inventory/switches', payload)
  },
  UPDATE_SWITCHES: (context, payload) => {
    return axiosInstance.put('/inventory/switches', payload)
  },
  DELETE_SWITCHES: (context, payload) => {
    return axiosInstance.delete('/inventory/switches?switch_id=' + payload)
  },
  GET_SWITCHE_PORTS_USAGE: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/switch_ports_usage?switch_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_SWITCHE_PORTS_USAGE', result.data)
    }
  },
  GET_DHCP_POOL_LINKS: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/dhcp_pool_links?switch_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_DHCP_POOL_LINKS', result.data)
    }
  },
  UPDATE_DHCP_POOL_LINKS: (context, payload) => {
    return axiosInstance.put('/inventory/dhcp_pool_links', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/inventory/switches.js